export default __webpack_public_path__ + "static/media/flag.ea275ed5.svg";